export const CANOPY_ROW_NAME = "velvetlineCap";

export const GLASPLAAT_DAK_ARTICLES = ["glass", "glassdark", "glassMelk"];

export const POLY_DEFAULT_ARTICLE = "polymid";

export const POLY_LIST_PRICES: Record<string, number> = {
  polylight: 61,
  polymid: 61,
  polydark: 93.25,
  polywide: 95.5,
};

export const getPolySurcharge = (name: string) =>
  (POLY_LIST_PRICES[name] ?? 0) - POLY_LIST_PRICES[POLY_DEFAULT_ARTICLE];

export const MONTAGE_MINIMUM = 1495;

export const getMontageAmount = (subtotal: number, percent: number) =>
  Math.max(subtotal * (percent / 100), MONTAGE_MINIMUM);

export const STAANDER_MEERPRIJS = 17.99;
export const STAANDER_MEERPRIJS_MIN_HEIGHT = 2200;
export const STAANDER_GROUND_DEPTH_M = 0.3;
export const STAANDER_STOCK_LENGTHS_M = [2.5, 3.1];

export const getStaanderLengthInMeters = (clearHeightInMeters: number) => {
  const requiredInMm = Math.round(
    (clearHeightInMeters + STAANDER_GROUND_DEPTH_M) * 1000
  );
  const stockLength = STAANDER_STOCK_LENGTHS_M.find(
    (length) => requiredInMm <= Math.round(length * 1000)
  );

  return (
    stockLength ?? STAANDER_STOCK_LENGTHS_M[STAANDER_STOCK_LENGTHS_M.length - 1]
  );
};

export const getStaanderMeerprijsQuantity = (
  heightInMm: number,
  staanderCount: number
) => (heightInMm > STAANDER_MEERPRIJS_MIN_HEIGHT ? staanderCount : 0);

export const formatCanopySizeInCm = (widthInMm: number, depthInMm: number) =>
  `${(widthInMm / 10).toLocaleString("nl-NL")} x ${(
    depthInMm / 10
  ).toLocaleString("nl-NL")}`;

export const toEuro = (price: number) => {
    return price.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export const toEuroRound = (price: number) => {
    return price.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
}

export const toEuroSigned = (delta: number) => {
    if (Math.round(delta) === 0) return "";

    return `${delta > 0 ? "+ " : "- "}${toEuroRound(Math.abs(delta))}`;
}
